import Cart from '@/views/order/cart.vue'
import login from '@/views/login/login.vue'
import category from '@/views/goods/category.vue'

const normalRoutes= [
  {
    path: '*',
    redirect: '/404'
  },{
    path: '/404',
    name: 'error404',
    component: ()=> import ('@/views/error/404.vue')
  },{
    path: '/wechath5pay',
    name: 'wechath5pay',
    component: ()=> import ('@/views/error/wechath5pay.vue')
  },{
    path: '/',
    name: 'index',
    component: ()=> import ('@/views/index/index.vue'),
    meta:{
      showTabbar: true
    }
  },{
    path: '/cameraPhoto',
    name: 'index',
    component: ()=> import ('@/views/camera/index.vue'),
  },{
    path: '/storeOrderList',
    name: 'index',
    component: ()=> import ('@/views/order/storeOrderList.vue'),
  },
  {
    path: '/category',
    name: 'category',
    component:category,
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/list',
    name: 'list',
    component: ()=> import ('@/views/goods/list.vue'),
    meta:{
      keepAlive: true
    }
  },
  {
    path: '/enterpriseGoods',
    name: 'enterpriseGoods',
    component: ()=> import ('@/views/goods/enterpriseGoods.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/enterpriseGoodsInvalid/:enterpriseName',
    name: 'enterpriseGoodsInvalid',
    component: ()=> import ('@/views/goods/enterpriseGoodsInvalid.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/88vip',
    name: '88vip',
    component: ()=> import ('@/views/user/membership.vue')
  },
  {
    path: '/lingquyouhuiquan',
    name: 'lingquyouhuiquan',
    component: ()=> import ('@/views/user/lingquyouhuiquan.vue')
  },
  {
    path: '/xieyi',
    name: 'xieyi',
    component: ()=> import ('@/views/user/xieyi.vue')
  },
  {
    path: '/detail/:goodsId',
    name: 'detail',
    component: ()=> import ('@/views/goods/detail.vue')
  },
  {
    path: '/photo',
    name: 'photo',
    component: ()=> import ('@/views/goods/photo.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component:Cart,
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component:login,
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/order-confirm',
    name: 'orderConfirm',
    component: ()=> import ('@/views/order/order-confirm.vue')
  },{
    path: '/order-pay',
    name: 'order-pay',
    component: ()=> import ('@/views/order/order-pay.vue')
  },{
    path: '/alipay-qr',
    name: 'alipay-qr',
    component: ()=> import ('@/views/order/alipay-qr.vue')
  },{
    path: '/order-success',
    name: 'order-success',
    component: ()=> import ('@/views/order/order-success.vue')
  },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: ()=> import ('@/views/user/updatePassword.vue')
  },
  {
    path: '/balance',
    name: 'balance',
    component: ()=> import ('@/views/user/balance.vue')
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: ()=> import ('@/views/user/recharge.vue')
  },
  {
    path: '/vip-pay',
    name: 'vip-pay',
    component: ()=> import ('@/views/user/vipPay.vue')
  },
  {
    path: '/order-list',
    name: 'order-list',
    component: ()=> import ('@/views/order/order-type.vue')
  },{
    path: '/order-detail/:orderId',
    name: 'order-detail',
    component: ()=> import ('@/views/order/order-detail.vue')
  },{
    path: '/invoice-all',
    name: 'invoice-all',
    component: ()=> import ('@/views/order/invoice-all.vue')
  },{
    path: '/invoice-view',
    name: 'invoice-view',
    component: ()=> import ('@/views/order/invoice-view.vue')
  },{
    path: '/invoice-pdf',
    name: 'invoice-pdf',
    component: ()=> import ('@/views/order/invoice-pdf.vue')
  },{
    path: '/order-aftersale-detail/:goodsId',
    name: 'order-aftersale-detail',
    component: ()=> import ('@/views/order/order-aftersale-detail.vue')
  },{
    path: '/user',
    name: 'user',
    component: ()=> import ('@/views/user/user-center.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/user/mobile-number',
    name: 'mobile-number',
    component: ()=> import ('@/views/user/mobile-number.vue')
  },{
    path: '/coupon',
    name: 'coupon',
    component: ()=> import ('@/views/user/coupon.vue')
  },{
    path: '/search',
    name: 'search',
    component: ()=> import ('@/views/search/search.vue')
  },
  {
    path: '/cloudDetail',
    name: 'cloudDetail',
    component: ()=> import ('@/views/goods/cloudDetail.vue')
  },
  {
    path: '/scene/:sceneCode',
    name: 'scene',
    component: ()=> import ('@/views/goods/scene.vue')
  },
  {
    path: '/industryList',
    name: 'industryList',
    component: ()=> import ('@/views/industry/industryList.vue')
  },
  {
    path: '/templateCategory',
    name: 'templateCategory',
    component: ()=> import ('@/views/goods/templateCategory.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/order-idphoto-detail/:orderId',
    name: 'order-idphoto-detail',
    component: ()=> import ('@/views/hcy/order-idphoto.vue')
  },
  {
    path: '/idphoto-receive-design',
    name: 'idphoto-receive-design',
    component: ()=> import ('@/views/hcy/idphoto-receive-design.vue')
  },
  {
    path: '/wxMiniprogramLink',
    name: 'wxMiniprogramLink',
    component: ()=> import ('@/views/index/linkPages/wxMiniprogramLink.vue')
  },
  {
    path: '/88vipLink',
    name: '88vipLink',
    component: ()=> import ('@/views/index/linkPages/88vipLink.vue')
  },
  {
    path: '/rechargeLink',
    name: 'rechargeLink',
    component: ()=> import ('@/views/index/linkPages/rechargeLink.vue')
  },
  {
    path: '/showOuerDetail',
    name: 'showOuerDetail',
    component: ()=> import ('@/views/goods/showOuerDetail.vue')
  },
]
// 云协作路由
const cloudCooperationRoutes= [
  {
    path: '*',
    redirect: '/404'
  },{
    path: '/404',
    name: 'error404',
    component: ()=> import ('@/views/error/404.vue')
  },{
    path: '/',
    name: 'index',
    component: ()=> import ('@/views/user/myalbum.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/goods-list',
    name: 'goods-list',
    component: ()=> import ('@/views/album/goods/list.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/detail/:goodsId',
    name: 'detail',
    component: ()=> import ('@/views/goods/detail.vue')
  },
  {
    path: '/cloudDetail',
    name: 'cloudDetail',
    component: ()=> import ('@/views/goods/cloudDetail.vue')
  },
  {
    path: '/order-confirm',
    name: 'orderConfirm',
    component: ()=> import ('@/views/order/order-confirm.vue')
  },{
    path: '/order-pay',
    name: 'order-pay',
    component: ()=> import ('@/views/order/order-pay.vue')
  },{
    path: '/alipay-qr',
    name: 'alipay-qr',
    component: ()=> import ('@/views/order/alipay-qr.vue')
  },{
    path: '/order-success',
    name: 'order-success',
    component: ()=> import ('@/views/order/order-success.vue')
  },{
    path: '/order-list',
    name: 'order-list',
    component: ()=> import ('@/views/order/order-type.vue')
  },{
    path: '/order-detail/:orderId',
    name: 'order-detail',
    component: ()=> import ('@/views/order/order-detail.vue')
  },{
    path: '/order-aftersale-detail/:goodsId',
    name: 'order-aftersale-detail',
    component: ()=> import ('@/views/order/order-aftersale-detail.vue')
  },{
    path: '/user',
    name: 'user',
    component: ()=> import ('@/views/user/user-center.vue'),
    meta:{
      showTabbar: true
    }
  },{
    path: '/coupon',
    name: 'coupon',
    component: ()=> import ('@/views/user/coupon.vue')
  },{
    path: '/search',
    name: 'search',
    component: ()=> import ('@/views/search/search.vue')
  },{
    path: '/order-success-program',
    name: 'order-success-program',
    component: ()=> import ('@/views/order/order-success-program.vue')
  },
  {
    path: '/user/mobile-number',
    name: 'mobile-number',
    component: ()=> import ('@/views/user/mobile-number.vue')
  },
  {
    path: '/user/uplode-cover',
    name: 'uplode-cover',
    component: ()=> import ('@/views/user/uplode-cover.vue')
  }
]
// 如琢团购路由
const rzGroupBuy= [
  {
    path: '*',
    redirect: '/404'
  },{
    path: '/404',
    name: 'error404',
    component: ()=> import ('@/views/error/404.vue')
  },{
    path: '/',
    name: 'index',
    component: ()=> import ('@/views/ruzhuo/index-rz.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: ()=> import ('@/views/login/login.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/cart',
    name: 'cart',
    component: ()=> import ('@/views/order/cart.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/order-confirm',
    name: 'orderConfirm',
    component: ()=> import ('@/views/order/order-confirm.vue')
  },
  {
    path: '/order-pay',
    name: 'order-pay',
    component: ()=> import ('@/views/order/order-pay.vue')
  },{
    path: '/alipay-qr',
    name: 'alipay-qr',
    component: ()=> import ('@/views/order/alipay-qr.vue')
  },{
    path: '/order-success',
    name: 'order-success',
    component: ()=> import ('@/views/order/order-success.vue')
  },{
    path: '/order-list',
    name: 'order-list',
    component: ()=> import ('@/views/order/order-list.vue')
  },{
    path: '/order-detail/:orderId',
    name: 'order-detail',
    component: ()=> import ('@/views/order/order-detail.vue')
  },
  {
    path: '/invoice-all',
    name: 'invoice-all',
    component: ()=> import ('@/views/order/invoice-all.vue')
  },
  {
    path: '/invoice-view',
    name: 'invoice-view',
    component: ()=> import ('@/views/order/invoice-view.vue')
  },
  {
    path: '/',
    name: 'category',
    component: ()=> import ('@/views/ruzhuo/newCategory.vue'),
    meta:{
      showTabbar: true
    }
  }, {
    path: '/detail/:goodsId',
    name: 'detail',
    component: ()=> import ('@/views/ruzhuo/goods-detail.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: ()=> import ('@/views/ruzhuo/search-rz.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: ()=> import ('@/views/ruzhuo/user-rz.vue'),
    meta:{
      showTabbar: true
    }
  },
  {
    path: '/user/mobile-number',
    name: 'mobile-number',
    component: ()=> import ('@/views/user/mobile-number.vue')
  },
  {
    path: '/apply-leader',
    name: 'apply-leader',
    component: ()=> import ('@/views/ruzhuo/apply-leader.vue')
  },
  {
    path: '/leader-center',
    name: 'leader-center',
    component: ()=> import ('@/views/ruzhuo/leader-center.vue')
  },
  {
    path: '/withdraw-log',
    name: 'withdraw-log',
    component: ()=> import ('@/views/ruzhuo/withdraw-log.vue')

  },{
    path: '/nearby-leader',
    name: 'nearby-leader',
    component: ()=> import ('@/views/ruzhuo/nearby-leader.vue')
  },
  {
    path: '/search-rz',
    name: 'search-rz',
    component: ()=> import ('@/views/ruzhuo/search-rz.vue')
  },
  {
    path: '/new-leader',
    name: 'new-leader',
    component: ()=> import ('@/views/ruzhuo/new-leader.vue')
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: ()=> import ('@/views/ruzhuo/withdraw.vue')
  },
  {
    path: '/user-leaders',
    name: 'user-leaders',
    component: ()=> import ('@/views/ruzhuo/user-leaders.vue')
  },
  {
    path: '/withdraw-detail',
    name: 'withdraw-detail',
    component: ()=> import ('@/views/ruzhuo/withdraw-detail.vue')
  },
  {
    path: '/earnings-order',
    name: 'earnings-order',
    component: ()=> import ('@/views/ruzhuo/earnings-order.vue')
  },
  {
    path: '/leader-info',
    name: 'leader-info',
    component: ()=> import ('@/views/ruzhuo/leader-info.vue')
  },{
    path: '/order-success-program',
    name: 'order-success-program',
    component: ()=> import ('@/views/order/order-success-program.vue')
  },
  {
    path: '/order-share',
    name: 'order-share',
    component: ()=> import ('@/views/ruzhuo/order-share.vue')
  },{
    path: '/order-aftersale-detail/:goodsId',
    name: 'order-aftersale-detail',
    component: ()=> import ('@/views/order/order-aftersale-detail.vue')
  }
]

var list = {
  normalRoute: normalRoutes,
  cloudCooperation: cloudCooperationRoutes,
  rzGroupBuy: rzGroupBuy
}

export default list



// WEBPACK FOOTER //
// ./src/router/routerList.js